'use client';

import { FC } from 'react';
import { AbTestingFeature } from '@wwe-portal/entities/ab-testing.type';
import {
  useUserExperiment,
  UseUserExperimentOptions,
} from '@wwe-portal/web/providers/queries/user-info';

interface AbTestingProps {
  feature: AbTestingFeature;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  placeholder?: React.ReactNode;
  options?: UseUserExperimentOptions;
}

export const AbTesting: FC<AbTestingProps> = ({
  feature,
  children,
  placeholder = null,
  fallback = null,
  options,
}) => {
  const { isEnabled, isLoading } = useUserExperiment(feature, options);
  if (isLoading) {
    return placeholder;
  }

  return isEnabled ? children : fallback;
};
